module.exports = __webpack_public_path__ + "img/sell.55d80a4f.png";